/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { css } from '@emotion/react'

export const amenitiesColumnSection = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 63px;
  margin-top: 14px;
  overflow: hidden;
  align-content: space-between;
`
export const amenitiesColumnSectionMobile = css`
  margin-top: 22px;
`
export const amenitiesColumnSectionLarge = css`
  ${amenitiesColumnSection};
  height: 135px;
`
